
import { Vue, Options } from 'vue-class-component';
import BaseSelect from './BaseSelect.vue';
import { BaseTextarea } from '@/lib/components/Textarea';
import { IOption, IValidationError } from '@/lib';
import { ConsultResolveService } from '@/services/api';
import { ResolveReasonValue, RESOLVE_REASON_MAX_LENGTH } from '@/models';

@Options({
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        selectedReason: '',
        additionalReason: ''
      })
    }
  },
  components: { BaseSelect, BaseTextarea }
})
export default class ResolveReason extends Vue {
  modelValue!: ResolveReasonValue;

  showAdditional = false;
  showLimitCharError = false;
  maxCharAdditionalInfo = 500;
  resolveReasonsOptions: IOption[] = [];

  private reasonMaxLength: number = RESOLVE_REASON_MAX_LENGTH;

  consultResolveService = new ConsultResolveService();
  fetchErrors: IValidationError | null = null;

  mounted() {
    this.fetchResolveReasonsOptions();
  }

  async fetchResolveReasonsOptions() {
    try {
      const response =
        await this.consultResolveService.getConsultResolveOptions();
      const list: string[] = response.data ?? (response as unknown as string[]);
      list.map((item) => {
        this.resolveReasonsOptions.push({
          label: this.$t(`custom.uhb.consult.resolve-reasons.${item}`),
          value: item
        });
      });
    } catch (e) {
      if (e.response?.status === 422) {
        this.fetchErrors = e.response?.data?.errors;
      } else {
        this.fetchErrors = {
          message: e.response?.data?.message || '',
          errors: {}
        };
      }
    }
  }

  get isReasonMandatory() {
    const status = this.modelValue.selectedReason === 'other';

    this.modelValue.selectedReason !== '' &&
      !this.showAdditional &&
      this.toggleAdditional();
    return status;
  }

  updateSelect(event) {
    this.setReason({ selectedReason: event });
  }

  toggleAdditional() {
    return (this.showAdditional = !this.showAdditional);
  }

  setReason(value: Partial<ResolveReasonValue>) {
    const updated = { ...this.modelValue, ...value };
    this.maxCharAdditionalInfo = 500 - updated.additionalReason.length;
    this.$emit('update-error-limit-char', this.maxCharAdditionalInfo);
    this.$emit('update:modelValue', { ...updated });
    this.$emit('select-reason', { ...updated });
  }
}
